<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>
  <div class="main-panel">
    <header class="topbar">
      <h1>Invitaciones</h1>
      <div class="topbar-right">
        <app-header-notification-bell [rol]="rol"></app-header-notification-bell>
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>
    <main class="content">
      <section class="card" *ngIf="!mostrarPanelInvitaciones">
        <h2>Invitaciones</h2>
        <p class="lead">{{ subtitulo }}</p>
        <p class="body">
          Este modulo queda disponible en el menu lateral segun rol para cumplir la navegacion homologada de la HU.
          El contenido funcional puede incorporarse despues sin cambiar la ruta ni la opcion del menu.
        </p>
        <div class="status-box">
          <span class="status-label">Rol actual</span>
          <strong>{{ rol }}</strong>
        </div>
      </section>

      <app-invitaciones-panel *ngIf="mostrarPanelInvitaciones" [rolSeleccionado]="rol"></app-invitaciones-panel>
    </main>
  </div>
</div>
